import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[60px] w-full rounded-xl border border-[#E4E8EF] bg-[#F1F5FA] px-3 py-2 text-base text-[#0B1620] shadow-sm placeholder:text-[#5B6675]/70 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#0B4F3F] focus-visible:border-[#0B4F3F]/60 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
